import makeStyles from '@mui/styles/makeStyles';
import {Pencil} from "lucide-react";
import {capitalize, get, isEmpty, map} from 'lodash';
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";
import EditUserProfile from "components/MyProfile/EditUserProfile";
import CtaButton from "components/redesign/CtaButton";
import ProfileCard from "components/redesign/ProfileCard";

const useStyles = makeStyles({
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  groupLabel: {
    ...type.eyebrow,
    fontWeight: font.BOLD,
    letterSpacing: '1.43px',
    color: color.SECTION_TITLE,
    margin: '8px 0 0',
  },
  editButton: {
    background: color.PURPLE_TINT,
    color: color.PURPLE,
    borderColor: 'transparent',
  },
});

const fullName = person =>
  `${get(person, 'firstName', '')} ${get(person, 'lastName', '')}`.trim();

const MyProfile = ({profile, partnerDetails, saveProfile}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const [editing, setEditing] = useState(false);

  const partners = get(partnerDetails, 'partnerDetails', []);
  const role = get(profile, 'role', '');

  return (
    <div className={classes.stack}>
      <ProfileCard
        isSelf
        eyebrow={`${capitalize(role)} ${t('profile')}`.trim()}
        name={fullName(profile)}
        memberId={get(profile, 'id')}
        picture={get(profile, 'picture')}
        email={get(profile, 'email')}
        phoneNumber={get(profile, 'phoneNumber')}
        bio={get(profile, 'bio')}
        action={
          <CtaButton
            size={'control'}
            variant={'secondary'}
            className={classes.editButton}
            icon={<Pencil size={14}/>}
            label={t('editProfile')}
            onClick={() => setEditing(true)}
          />
        }
      />

      {/* Everyone else in the mentorship, so the group is on the page rather
          than folded behind a panel. */}
      {!isEmpty(partners) && <p className={classes.groupLabel}>{t('yourGroup')}</p>}
      {map(partners, partner => (
        <ProfileCard
          key={get(partner, 'id')}
          eyebrow={`${t('your')} ${capitalize(get(partner, 'role', ''))}`.trim()}
          name={fullName(partner)}
          memberId={get(partner, 'id')}
          picture={get(partner, 'picture')}
          bio={get(partner, 'bio')}
        />
      ))}

      {editing && (
        <EditUserProfile
          open
          handleClose={() => setEditing(false)}
          saveProfile={saveProfile}
          firstName={get(profile, 'firstName', '')}
          lastName={get(profile, 'lastName', '')}
          bio={get(profile, 'bio', '')}
          picture={get(profile, 'picture', '')}
          phoneNumber={get(profile, 'phoneNumber', '')}
        />
      )}
    </div>
  );
};

export default MyProfile;
